export default "__VITE_ASSET__B6YiYc$O__"